import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {Char} from "../Char";

export class InputWord extends Component {
  render() {
    const { name, wrongWord } = this.props
    const status = wrongWord ? 'invalid' : 'none'

    return (
        <div className="mx-auto grid w-full max-w-[340px] grid-cols-5 gap-1.5">
          <Char status={status} char={name[0]} />
          <Char status={status} char={name[1]} />
          <Char status={status} char={name[2]} />
          <Char status={status} char={name[3]} />
          <Char status={status} char={name[4]} />
        </div>
    )
  }
}

InputWord.propTypes = {
  chosenName: PropTypes.array,
  wordList: PropTypes.array,
  wrongWord: PropTypes.bool,
  name: PropTypes.any
};
